import { Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { useAuthUser } from 'auth/hooks';
import { Color, Level } from 'theme/enums';

interface IProps {
  label?: string;
  userId?: string;
  firstName?: string;
  lastName?: string;
}

export const UserName = ({ label, userId, firstName, lastName }: IProps) => {
  const { t } = useTranslation();

  const { user } = useAuthUser();

  if (!userId && !firstName && !lastName) {
    return null;
  }

  const content =
    Number(userId) === user?.id ? (
      t('labelYou')
    ) : (
      <Typography color={Color.PRIMARY}>
        {firstName} {lastName}
      </Typography>
    );

  return (
    <Typography level={Level.BODY_XS}>
      {label} {content}
    </Typography>
  );
};
